import { deleteExternalConnection as _deleteExternalConnection } from '@griply/services';
import { deleteDoc, doc, getFirestore } from 'firebase/firestore';
import { ID } from 'shared/types/id';

export const deleteExternalConnection = (id: ID): Promise<void> =>
  _deleteExternalConnection({
    id,
    doc,
    deleteDoc,
    db: getFirestore(),
  });
